import { useQuery } from 'hooks/useCustomQuery';

async function getNasaImageOfDay() {
    const res = await fetch(
        'https://api.nasa.gov/planetary/apod?api_key=VKrdDxR2J9gaBTICmIWsDGN57FIiOLFg4tZaQKHe&thumbs=true',
    );
    if (!res.ok) {
        throw new Error('Failed to fetch NASA image');
    }
    const data = await res.json();
    return data;
}

// Custom hook for NASA API with proper caching
/**
 * @note Custom hook for fetching NASA API daily
 * @param {boolean} [enabled=false] this condition will depend on background options type is 4 or not
 * */
function useNasaImageOfDay(enabled = false) {
    return useQuery({
        queryKey: ['nasaImageOfDay'],
        queryFn: getNasaImageOfDay,
        staleTime: 12 * 60 * 60 * 1000, // NASA updates daily, so 12-24 hours
        cacheTime: 12 * 60 * 60 * 1000, // 12 hours
        enabled,
        retry: 2,
        refetchOnWindowFocus: false,
    });
}

export { useNasaImageOfDay };
